import { memo, useRef, useState } from 'react';
import styled from 'styled-components';

import { useOnOutsideClick } from '../../hooks/useOnOutsideClick';
import { SlideElementIframeType } from './slide.types';

const SlideElementIframe = ({
  element,
  slideMode = 'view',
  isInteract = false,
}: {
  element: SlideElementIframeType;
  slideMode: 'view' | 'edit';
  isInteract?: boolean;
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeInteract, setIframeInteract] = useState(
    slideMode === 'view' ? true : isInteract,
  );
  const handleOutsideClick = () => {
    if (slideMode === 'view') return;
    setIframeInteract(false);
  };

  useOnOutsideClick(iframeRef, handleOutsideClick);
  return (
    <IframeWrapper
      ref={iframeRef}
      $borderRadius={element.borderRadius}
      onMouseOver={() => {
        if (slideMode === 'view') return;
        setIframeInteract(true);
      }}
    >
      <IframeMedia
        src={element.mediaUrl}
        $zIndex={iframeInteract ? 0 : -1}
        allow={slideMode === 'view' ? 'fullscreen' : ''}
      />

      <IFrameOverlay $zIndex={iframeInteract ? -1 : 0} />
    </IframeWrapper>
  );
};

const IframeWrapper = styled.div<{ $borderRadius?: number }>`
  width: 100%;
  height: 100%;
  background-color: black;
  position: relative;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  overflow: hidden;
`;
const IframeMedia = styled.iframe<{ $zIndex: number }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${({ $zIndex }) => $zIndex}
  background-color: black;
  box-shadow: none;
  border: none;
`;
const IFrameOverlay = styled.div<{ $zIndex?: number }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${({ $zIndex }) => $zIndex};
`;
export default memo(SlideElementIframe);
